import { CAPABILITIES, Capability } from '@/config/platform';
import { redirect } from '@tanstack/react-router';

/// Ferme une page aux cibles qui n'ont pas la capacité, dans un `beforeLoad`.
/// Masquer l'entrée du menu ne suffit pas : une adresse reste atteignable, et
/// un examinateur d'Apple la trouvera.
export function requireCapability(capability: Capability) {
  if (!CAPABILITIES[capability]) throw redirect({ to: '/dashboard' });
}
